// extracted by mini-css-extract-plugin
module.exports = {"mark":"CellContent_mark__3pu0O","checkbox":"CellContent_checkbox__1XIS9","desktop":"CellContent_desktop__2bXxB","link":"CellContent_link__VcSKB"};